'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Promise = undefined;

var _utilsPolyfills = require('./utils.polyfills.js');

var ogPromise = global.Promise;

function $Promise(fn) {
    var res,
        rej,
        promise = new ogPromise(function (resolve, reject) {
        res = resolve;
        rej = reject;

        fn && fn(resolve, reject);
    });

    promise.resolve = function () {
        res.apply(promise, [].slice.call(arguments));
    };

    promise.reject = function () {
        rej.apply(promise, [].slice.call(arguments));
    };

    return promise;
}

['all', 'resolve', 'reject'].forEach(function (key) {
    $Promise[key] = ogPromise[key];
});

var Promise = exports.Promise = $Promise;

exports.default = $Promise;


//////////////////
// WEBPACK FOOTER
// ./~/ereader-core/dist/utils.Promise.js
// module id = 235
// module chunks = 0